import React, { useState } from "react";
import logo from "../assets/images/AES.png";

const Navbar = () => {
  const [menuName, setMenuName] = useState("menu");
  const [menuVisible, setMenuVisible] = useState(true);
  const [navLinksClass, setNavLinksClass] = useState("nav-links");

  // const onToggleMenu = () => {
  //   setMenuName((prevName) => (prevName === "menu" ? "close" : "menu"));
  //   setMenuVisible((prevVisible) => !prevVisible);
  //   setNavLinksClass((prevClass) =>
  //     prevClass === "nav-links" ? "top-[9%]" : "nav-links"
  //   );
  // };
  // <div
  //         class={`nav-links duration-500 md:static absolute md:min-h-fit min-h-[60vh] left-0 top-[-100%]
  //         md:w-auto w-full flex items-center px-5 ${
  //           menuVisible ? "" : "hidden"
  //         }`}
  //       ></div>
  return (
    <header class="absolute w-full">
      <nav class="flex justify-between items-center w-[92%] mt-[-30px]">
        <div>
          <img
            src={logo}
            alt="Logo"
            class="w-[231px] h-[231px] drop-shadow-lg cursor-pointer"
          />
        </div>
        <div
          class="nav-links duration-500 md:static absolute md:min-h-fit min-h-[60vh] left-0 top-[-100%] 
          md:w-auto w-full flex items-center px-5
        "
        >
          <ul class="flex md:flex-row flex-col md:items-center md:gap-[4vw] gap-8">
            <li>
              <a
                class="text-white hover:text-[#a53835] text-2xl font-normal drop-shadow-lg"
                href="#"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                class="text-white hover:text-[#a53835] text-2xl font-normal drop-shadow-lg "
                href="#"
              >
                Our Team
              </a>
            </li>
            <li>
              <a
                class="text-white hover:text-[#a53835] text-2xl font-normal drop-shadow-lg "
                href="#"
              >
                Our Services
              </a>
            </li>
            <li>
              <a
                class="text-white hover:text-[#a53835] text-2xl font-normal drop-shadow-lg"
                href="#"
              >
                Our Clients
              </a>
            </li>
            <li>
              <a
                class="text-white hover:text-[#a53835] text-2xl font-normal "
                href="#"
              >
                Careers
              </a>
            </li>
          </ul>
        </div>
        <div class="flex items-center gap-6">
          <button class="bg-[#bd6961] text-white px-6 py-3 rounded-full hover:bg-[#7a3432] duration-500">
            Contact Us
          </button>
          {/* <ion-icon
            onClick={onToggleMenu}
            name={menuName}
            class="md:hide text-3xl cursor-pointer "
          ></ion-icon> */}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
